module.exports = __webpack_public_path__ + "static/media/teste.9483b51b.png";